<div *ngIf="visible" class="success-banner" [ngClass]="type">
  <fa-icon 
    [icon]="type === 'like' ? faCheck : faHeartBroken">
  </fa-icon> 
  &nbsp;{{ message }}
</div>